enum ST0 {
  RECORD_KEY = "record",
  SUCCESS_UUID_KEY = "uuid",
  TEMP_UUID_KEY = "tempUuid",
  SELECTED_UUID_KEY = "selected",
  NATIONAL_ID_KEY = "nid",
  DATE_OF_BIRTH_KEY = "dob",
}

export default ST0
